module.exports = __webpack_public_path__ + "static/media/spam-inactive.3839f96e.svg";